module.exports = __webpack_public_path__ + "static/media/spoonerism-task (6).77c5d16e.mp3";